import React from "react"
import Select, {StylesConfig} from "react-select"
import {countries} from "../../resources/countries"
import {Editable, EditableElementProps} from "../HorizontalField/EditableHorizontalField"
import HorizontalField from "../HorizontalField/HorizontalField"

interface CountryOption {
	readonly value: string
	readonly label: string
}

const countryOptions: CountryOption[] = Object.entries(countries).map(([code, name]) => ({
	value: code,
	label: name,
}))

const selectStyles: StylesConfig<CountryOption, true> = {
	control: (base, state) => ({
		...base,
		borderColor: state.isFocused ? "#000000" : base.borderColor,
		"&:hover": {
			borderColor: state.isFocused ? "#000000" : base.borderColor,
		},
		minHeight: 38,
	}),
	container: (base) => ({
		...base,
		width: "100%",
	}),
}

function EditableCountriesOfOperationInput(props: EditableElementProps<string[]>) {
	const selectedOptions = countryOptions.filter((option) => props.value.includes(option.value))

	if (props.isEditing) {
		return (
			<Select<CountryOption, true>
				isMulti
				value={selectedOptions}
				options={countryOptions}
				onChange={(newValue) => props.setValue(newValue.map((value) => value.value))}
				styles={selectStyles}
				placeholder="Select countries..."
				closeMenuOnSelect={false}
				hideSelectedOptions={false}
				menuPlacement="auto"
			/>
		)
	}

	return (
		<React.Fragment>
			{selectedOptions.map((option: CountryOption) => (
				<span key={option.value} className="tag is-light country-tag">
					{option.value}
				</span>
			))}
		</React.Fragment>
	)
}

export interface EditableCountriesOfOperationProps {
	countriesOfOperation?: string[]
	setCountriesOfOperation: (value: string[]) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	isUpdating: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: string[]) => void
	className?: string
}

export function EditableCountriesOfOperationField(props: EditableCountriesOfOperationProps) {
	if (props.countriesOfOperation === undefined) {
		return null
	}

	return (
		<Editable
			label="Countries of Operation"
			isEditing={props.isEditing}
			isDisabled={props.isDisabled}
			isAllowed={props.isAllowed}
			onStartEdit={props.onStartEdit}
			onCancel={props.onCancel}
			setValue={props.setCountriesOfOperation}
			value={props.countriesOfOperation}
			initial={props.countriesOfOperation}
			update={props.update}
			className={props.className}
		>
			{EditableCountriesOfOperationInput}
		</Editable>
	)
}

export function CountriesOfOperation(props: {countriesOfOperation?: string[]; isArchived: boolean}) {
	if (props.countriesOfOperation?.length !== 0 && props.countriesOfOperation) {
		return (
			<HorizontalField label={"Countries of Operation"} fieldClassName={props.isArchived ? "archived-field" : ""}>
				{props.countriesOfOperation.map((country) => (
					<span key={country} className="tag is-light country-tag">
						{country}
					</span>
				))}
			</HorizontalField>
		)
	}

	return (
		<HorizontalField label="Countries of Operation" fieldClassName={props.isArchived ? "archived-field" : ""}>
			<input type="text" readOnly className="input is-static" placeholder="Empty" />
		</HorizontalField>
	)
}
